import React, { useState } from "react";

import Dropdown from "components/general/Dropdown";
import Icon from "components/general/Icon";
// import { Link } from "react-router-dom";
import closeIcon from "images/ic_close.png";
import { connect } from "react-redux";
import iconBadge from "images/ic_badge.png";
import menuIcon from "images/ic_menu.png";
import styled from "styled-components";
import theme from "styles/theme";
import { useNavigate } from "react-router-dom";

const MobileBackground = styled.div`
  display: none;

  ${theme.media.phone`
    z-index: 500;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: ${(props) => (props.$isMenuOpen ? "auto" : "none")};

    background-color: ${theme.colors.gray4};
    transition: opacity 300ms;
    opacity: ${(props) => (props.$isMenuOpen ? 0.5 : 0)};
  `}
`;

const MobileMenuToggleContainer = styled.div`
  display: none;

  ${theme.media.phone`
    position: relative;
    display: inline-flex;
    width: 60px;
    height: 60px;
    justify-content: center;
    align-items: center;
    margin-right: -16px;
  `}
`;

const MobileMenuIconContainer = styled.div`
  position: relative;

  ${(props) =>
    props.$hasBadge &&
    `&::before {
        position: absolute;
        top: 50%;
        left: -12px;
        margin: -4px; /* half of height */
        content: "";
        display: block;
        background: url(${iconBadge}) no-repeat;
        background-size: contain;
        width: 8px;
        height: 8px;
      }`}
`;

const MobileMenuContent = styled.div`
  z-index: 501;
  display: none;
  position: fixed;
  left: 0;
  top: calc(-56px * ${(props) => props.$numOptions} - 16px);
  width: 100%;
  padding: ${theme.spacing.unit * 1}px 0;
  background-color: ${theme.colors.white};
  color: ${theme.colors.black};

  transition: transform 300ms ease-in-out;
  ${(props) =>
    props.$isMenuOpen &&
    `transform: translateY(calc(56px * ${props.$numOptions} + 16px + 60px))`};

  ${theme.media.phone`
    display: flex;
    flex-direction: column;
  `}
`;

const MobileMenuOption = styled.div`
  display: flex;
  width: 100%;
  height: 56px;
  align-items: center;
  box-sizing: border-box;
  padding: ${(props) => {
    let paddingLeft = `${theme.spacing.unit * 3}px`;
    if (props.$hasMenuBadge) {
      paddingLeft = `calc(${theme.spacing.unit * 3}px + 8px)`;
    }
    return `0 ${theme.spacing.unit * 3}px 0 ${paddingLeft}`;
  }};

  :hover,
  :active {
    background-color: ${theme.colors.gray1};
  }

  span {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: ${theme.colors.black};
  }

  b {
    font-weight: 600;
    color: ${theme.colors.gray4};
  }
`;

const MobileMenuOptionLabel = styled.div`
  position: relative;

  ${(props) => {
    let beforeElement = null;
    if (props.$hasBadge) {
      beforeElement = `&::before {  
          position: absolute;
          top: 50%;
          left: -12px;
          margin: -4px; /* half of height */
          content: "";
          display: block;
          background: url(${iconBadge}) no-repeat;
          background-size: contain;
          width: 8px;
          height: 8px;
        }`;
    } else if (props.$hasMenuBadge) {
      beforeElement = `&::before {
          position: absolute;
          top: 50%;
          left: -12px;
          margin: -4px; /* half of height */
          content: "";
          display: block;
          width: 8px;
          height: 8px;
        }`;
    }
    return beforeElement;
  }}
`;

const DropdownContainer = styled.div`
  display: inline-flex;

  ${theme.media.phone`
    display: none;
  `}
`;

export const HeaderMenu = ({ user }) => {
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleOutsideMobileMenuClick = (e) => {
    setIsMenuOpen(false);
  };

  // const handleSiteClick = (path) => (e) => {
  //   window.location = `https://careerpuck.com${path}`;
  // };

  const handleInternalClick = (path) => (e) => {
    setIsMenuOpen(false);
    navigate(path);
  };

  // const handleApplicationClick = (e) => {
  //   setIsMenuOpen(false);
  //   navigate("/applications");
  // };

  const handleMobileMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const hasUnreadNotifications = user.notifications
    ? user.notifications.filter((n) => n.state === "unread").length > 0
    : false;
  const hasMenuBadge = hasUnreadNotifications;

  let options = [];

  // This should only ever be rendered when we have a user already
  if (user.type === 1) {
    options.push({
      label: "Logout",
      onClick: handleInternalClick("/logout"),
    });
  } else {
    if (user.employerId) {
      // This is an employer-user

      if (user.hasJobPosts) {
        // if we have job-posts, then show the Candidates menu
        options.push({
          label: "Candidates",
          onClick: handleInternalClick(`/employer/${user.employerId}`),
        });
      }

      // // every employer-user gets the Job Clips menu
      // options.push({
      //   label: "Job clips",
      //   onClick: this.handleInternalClick(`/job-clip/`),
      // });

      if (user.hasJobPages) {
        // if there are Job Pages, show the Job Pages menu
        options.push(
          ...[
            {
              label: "Home",
              onClick: handleInternalClick(`/job-page`),
            },
            // {
            //   label: "Hello widget",
            //   onClick: this.handleInternalClick(`/hello-widget`),
            // },
          ]
        );
      }
    } else {
      // not an employer-user, show the Profile edit menu
      options.push({
        label: "Profile",
        onClick: handleInternalClick(`/profile/${user?.profile?.permalink}`),
      });
    }

    options.push(
      ...[
        {
          label: "Notifications",
          onClick: handleInternalClick("/notifications"),
          hasBadge: hasUnreadNotifications,
        },
        {
          label: "Settings",
          onClick: handleInternalClick("/employers/settings"),
        },
        { label: "Logout", onClick: handleInternalClick("/logout") },
      ]
    );
  }

  const mobileMenuContent = options.map((option, i) => (
    <MobileMenuOption
      key={i}
      onClick={option.onClick}
      $hasMenuBadge={hasMenuBadge}
    >
      <MobileMenuOptionLabel
        $hasMenuBadge={hasMenuBadge}
        $hasBadge={option.hasBadge}
      >
        {option.label}
      </MobileMenuOptionLabel>
    </MobileMenuOption>
  ));

  return (
    <>
      <MobileBackground
        $isMenuOpen={isMenuOpen}
        onClick={handleOutsideMobileMenuClick}
      />
      <MobileMenuContent $isMenuOpen={isMenuOpen} $numOptions={options.length}>
        {mobileMenuContent}
      </MobileMenuContent>
      <MobileMenuToggleContainer onClick={handleMobileMenuToggle}>
        <MobileMenuIconContainer $hasBadge={isMenuOpen ? false : hasMenuBadge}>
          <Icon src={isMenuOpen ? closeIcon : menuIcon} />
        </MobileMenuIconContainer>
      </MobileMenuToggleContainer>
      <DropdownContainer>
        <Dropdown
          title={[user.profile.firstName, user.profile.lastName].join(" ")}
          options={options}
          hasBadge={hasMenuBadge}
        />
      </DropdownContainer>
    </>
  );
};

function mapStateToProps(state) {
  const { auth } = state;

  return {
    user: auth.user,
  };
}

export default connect(mapStateToProps)(HeaderMenu);
